import { render, staticRenderFns } from "./ImagingProcedure.vue?vue&type=template&id=74071a9c&scoped=true"
import script from "./ImagingProcedure.vue?vue&type=script&lang=js"
export * from "./ImagingProcedure.vue?vue&type=script&lang=js"
import style0 from "./ImagingProcedure.vue?vue&type=style&index=0&id=74071a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74071a9c",
  null
  
)

export default component.exports